import Vue from 'vue'
import App from './App.vue'
import VueAnalytics from 'vue-analytics'
import { store } from './store/store'
import router from './router'
import GameCmp from './components/import/game.vue'
import GameResultCmp from './components/import/gameResult.vue'
import QuestionCmp from './components/import/question.vue'
import ProgressCmp from './components/import/progress.vue'

Vue.config.productionTip = false

Vue.component('gameCmp', GameCmp)
Vue.component('gameResultCmp', GameResultCmp)
Vue.component('questionCmp', QuestionCmp)
Vue.component('progressCmp', ProgressCmp)

Vue.use(VueAnalytics, {
  // dev analytics
  id: 'UA-130185303-1',
  // live analytics
  // id: 'UA-111708929-3',
  router
})

new Vue({
  store,
  router,
  render: h => h(App)
}).$mount('#app')
